export default __webpack_public_path__ + "7aa1726.png";